var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "1600"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-format-list-bulleted")]), _vm._v(" Lista de Presença ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.formacao,
      "label": "Formação",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.cargaHoraria,
      "label": "Carga Horária",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.$formatarData(_vm.content.dataRealizacao),
      "label": "Data de Realização",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.localRealizacao,
      "label": "Local de Realização",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Instrutor(es)")]), _c('div', {
    staticClass: "instrutores-box"
  }, [_c('v-chip-group', {
    attrs: {
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l(_vm.content.listaInstrutores, function (instrutor) {
    return _c('v-chip', {
      key: instrutor.id
    }, [_vm._v(" " + _vm._s(instrutor.nome) + " ")]);
  }), 1)], 1)])], 1), _c('v-data-table', {
    staticClass: "mt-5 tabela-presenca",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: "item.presente",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-radio-group', {
          attrs: {
            "disabled": _vm.content.bloquearCampos,
            "hide-details": ""
          },
          on: {
            "change": function (val) {
              if (val === 'Presente') item.ausente = null;
            }
          },
          model: {
            value: item.presente,
            callback: function ($$v) {
              _vm.$set(item, "presente", $$v);
            },
            expression: "item.presente"
          }
        }, [_c('v-radio', {
          staticClass: "mb-3",
          attrs: {
            "label": '',
            "value": "Presente"
          }
        })], 1)];
      }
    }, {
      key: `item.cpf`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$esconderCpf(item.cpf)) + " ")];
      }
    }, {
      key: "item.ausente",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-radio-group', {
          attrs: {
            "disabled": _vm.content.bloquearCampos,
            "hide-details": ""
          },
          on: {
            "change": function (val) {
              if (val === 'Ausente') item.presente = null;
            }
          },
          model: {
            value: item.ausente,
            callback: function ($$v) {
              _vm.$set(item, "ausente", $$v);
            },
            expression: "item.ausente"
          }
        }, [_c('v-radio', {
          staticClass: "mb-3",
          attrs: {
            "label": '',
            "value": "Ausente"
          }
        })], 1)];
      }
    }, {
      key: "top",
      fn: function () {
        return [_c('v-toolbar', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-spacer'), !_vm.content.bloquearCampos ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.abrirModalAdicionarParticipante
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("mdi-account-plus")])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }], null, true)
  }), !_vm.content.bloquearCampos ? _c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', [_vm._v(" Eu, "), _c('span', {
          staticClass: "blue--text"
        }, [_vm._v(_vm._s(_vm.$user.fullName))]), _vm._v(", CPF "), _c('span', {
          staticClass: "blue--text"
        }, [_vm._v(_vm._s(_vm.$formatCpf(_vm.$user.username)))]), _vm._v(", declaro, sob minha responsabilidade, que a confirmação de presença nesta formação foi realizada de forma consciente e verdadeira, estando plenamente ciente das implicações decorrentes desta declaração. ")])];
      },
      proxy: true
    }], null, false, 3942267676),
    model: {
      value: _vm.confirmacaoPresenca,
      callback: function ($$v) {
        _vm.confirmacaoPresenca = $$v;
      },
      expression: "confirmacaoPresenca"
    }
  })], 1)], 1) : _vm._e(), _vm.content.bloquearCampos ? _c('div', {
    staticClass: "d-flex justify-center mb-4"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('sigfoco-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  })], 1), _c('v-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1) : _c('v-row', {
    staticClass: "d-flex justify-center mb-4"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "color": "primary",
      "disabled": !_vm.confirmacaoPresenca
    },
    on: {
      "click": _vm.salvar
    }
  }, [_vm._v("Salvar")]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    model: {
      value: _vm.modalAdicionar,
      callback: function ($$v) {
        _vm.modalAdicionar = $$v;
      },
      expression: "modalAdicionar"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Incluir Usuário")])], 1), _c('v-card-text', {
    staticClass: "mt-7"
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF do Usuário",
      "outlined": "",
      "dense": "",
      "maxlength": "14",
      "disabled": _vm.desabilitaCamposUsuario
    },
    model: {
      value: _vm.novoParticipante.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.novoParticipante, "cpf", $$v);
      },
      expression: "novoParticipante.cpf"
    }
  }), _vm.novoParticipante.nome ? _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "Nome do Usuário",
      "readonly": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.novoParticipante.nome,
      callback: function ($$v) {
        _vm.$set(_vm.novoParticipante, "nome", $$v);
      },
      expression: "novoParticipante.nome"
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "d-flex justify-center"
  }, [!_vm.desabilitaCamposUsuario ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.aoBuscarCpf
    }
  }, [_vm._v("Buscar")]) : _vm._e(), !!_vm.novoParticipante.nome ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.confirmarAdicionarParticipante
    }
  }, [_vm._v("Salvar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.modalAdicionar = false;
        _vm.desabilitaCamposUsuario = false;
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }